import React from 'react'
import Balance from '../Button/Balance';

import Send from '../../Assets/Images/send-2.svg'
import Fund from '../../Assets/Images/wallet-add.svg'
import ModalComponent from '../Modal/Pin';
import { Link } from 'react-router-dom';
import { getBranding } from '../../utils/getBranding';

const BalanceCard = () => {

    const branding = getBranding();
 
   
 
    return (
        <>
            
       
        <div className='w-full rounded-lg  py-9 px-4 text-white md:flex gap-3 justify-between items-center' style={{ backgroundColor: branding.color.primary }}>
          
            <div>
                <p className='text-[14px]'>Log in, fund your wallet & enjoy more discounts!</p>

                <h1 className='text-[24px] font-[600] '>
                Don't have an account? <Link to={'/signup'} className=' underline'>SIGN UP</Link> 
                </h1>
            </div>

            <div className='flex'>
                <Balance Icon={Fund} text="Fund Wallet"  />

                <Balance Icon={Send} text="Send to User"  />
            </div>
               
          
        </div>
        </>
    );
}

const QuickActionCard = ({ card = [] }) => {
    const branding = getBranding();
    return (
        <div className='grid grid-cols-2 gap-2 items-center'>
            {card.map((cards, i) => (
                <>
                    <div key={i} onClick={cards.handleOpen} className='border  rounded-lg w-full flex flex-col justify-center items-center p-[70px] cursor-pointer' style={{ borderColor: branding.color.primary }}>
                    <div style={{ backgroundColor: branding.color.secondary }} className=' w-10 text-2xl  h-10 text-center p-2 text-white rounded-full'>
                     <cards.icon/>
                     </div>
                        <p className='text-nowrap mt-2 font-[500] text-[18px]'>{cards.actionName}</p>
                    </div>
                    <ModalComponent open={cards.open} handleClose={cards.handleClose}>
                        {cards.children}
                    </ModalComponent>
                </>
            ))}



        </div>
    )
}




export { BalanceCard, QuickActionCard};